import { AtlasMenuContentItem, Button, Menu } from "@resource/atlas";
import { useMemo } from "react";

import { PaginatedTableFieldFilterOption } from "./types";

export default function SingleSelectFilter({
  fieldId,
  value,
  options,
  setFilter,
  disabled,
}: {
  fieldId: string;
  value: string;
  options?: PaginatedTableFieldFilterOption[];
  setFilter: (id: string, val: string | null) => void;
  disabled?: boolean;
}) {
  const menuItems = useMemo(
    () =>
      options?.map(
        (option): AtlasMenuContentItem => ({
          _type: "item",
          children: option.caption,
          key: option.id,
          isSelectable: true,
          isSelected: value === option.id,
          onSelect: () => {
            setFilter(fieldId, option.id);
          },
        })
      ),
    [options, value, setFilter, fieldId]
  );

  const selectedOption = useMemo(
    () => options?.find((o) => o.id === value),
    [options, value]
  );

  return (
    <Menu.Root>
      <Menu.Trigger>
        <Button isGhost isDropdown disabled={disabled}>
          {selectedOption?.caption ?? ""}
        </Button>
      </Menu.Trigger>
      <Menu.Content
        style={{ minWidth: 190 }}
        defaultSize="compact"
        items={menuItems}
      />
    </Menu.Root>
  );
}
